import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withTracking from '../../../utils/tracking/components/withTracking';
import { detectAdBlocker } from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';

class DetectAdBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adBlockDetected: false
    };
    this.detectAdBlocker = this.detectAdBlocker.bind(this);
  }
  componentDidMount() {
    this.detectAdBlocker();
  }
  componentWillUpdate(nextProps) {
    if (this.props.pathname !== nextProps.pathname) {
      this.detectAdBlocker();
    }
  }
  detectAdBlocker() {
    const head = document.getElementsByTagName('head')[0];

    const noAdBlockDetected = () => {
      this.setState({
        adBlockDetected: false
      });
    };
    const adBlockDetected = () => {
      // [DataLayer] trigger nav item click event
      const clickEvent = new EventModel(
        'Ad Blocker Detected',
        'adBlockerDetect',
        'adBlocker',
        'adBlocker'
      );
      this.props.trackAdBlock(clickEvent.getTrackingObject());

      this.setState({
        adBlockDetected: true
      });
    };
    // clean up stale bait
    const oldScript = document.getElementById('adblock-detection');
    if (oldScript) {
      head.removeChild(oldScript);
    }
    // we will dynamically generate some 'bait'.
    const script = document.createElement('script');
    script.id = 'adblock-detection';
    script.type = 'text/javascript';
    script.src = 'https://www.inc.com/js/ads.js';
    script.onload = noAdBlockDetected;
    script.onerror = adBlockDetected;
    head.appendChild(script);
  }
  noticeContentJSX() {
    return (
      <div id="adblock-notice" style={{ display: 'none' }}>
        {/* <div className="message">
          <h3>Hey, you!</h3>
          <p>Your adblocker is on again.</p>
          <button onClick={this.detectAdBlocker}>
            Check for Adblocker again
          </button>
        </div> */}
      </div>
    );
  }
  render() {
    return (
      <div id="adblock-wrapper">
        {this.state.adBlockDetected ? this.noticeContentJSX() : null}
      </div>
    );
  }
}

DetectAdBlock.defaultProps = {
  trackAdBlock: () => false,
  pathname: 'default'
};

DetectAdBlock.propTypes = {
  pathname: PropTypes.string,
  trackAdBlock: PropTypes.func
};

const mapTrackingToProps = trackEvent => ({
  trackAdBlock: pageObject => trackEvent(detectAdBlocker(pageObject))
});

const trackedDetectAdBlock = withTracking(mapTrackingToProps)(DetectAdBlock);

export default trackedDetectAdBlock;
